import '../../App.css';
import {Badge, Form} from 'react-bootstrap';
import {Button} from 'react-bootstrap';
import {Alert} from 'react-bootstrap';
import {Link} from 'react-router-dom'
import {Bodyheadregister} from '../bodyheadregister';
import {useNavigate} from "react-router-dom";
import Axios from 'axios';
import React, {useEffect, useState} from 'react';
//import io from 'socket.io-client';
import { io } from 'socket.io-client';
import { clearImpersonationState } from '../../utils/impersonation';

function Bodylogin(props) {
    const [profile, setProfile] = useState([]);
    const [user, setUser] = useState('');
    const [userType, setUserType] = useState('1');
    const [pass, setPass] = useState('');
    const [alertHead, setAlertHead] = useState('');
    const [alertBody, setAlertBody] = useState('');
    const [alertActivate, setAlertActivate] = useState(false);
    const [alertClass, setAlertClass] = useState('')
    const [authCode, setAuthCode] = useState('');
    const [apiKey, setApiKey] = useState('');
    const [socketId, setSocketId] = useState('');
    const [socket, setSocket] = useState(null);

    let statuscall = ''
    const navigate = useNavigate();

    const profileList = profile.map((item, i) =>
        <option key={i} value={item.id}>{item.nombre}</option>
    );

    useEffect(() => {
        Axios.get(process.env.REACT_APP_URLPROFILE, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setProfile(response.data);
        }).catch(error => {
            return error
        });
    }, []);

    useEffect(() => {
        const URL = process.env.REACT_APP_URLSOCKETIO || window.location.origin;
        console.log('Socket URL:', URL); // verifica que NO tenga /socket.io ni puerto 3001

        const s = io(URL, {
            path: '/socket.io/',                  // explícito para que calce con NGINX y el server
            transports: ['websocket'],
            reconnection: true,
            reconnectionAttempts: 5,
            reconnectionDelay: 500
        });

        setSocket(s);

        s.on('connect', () => {
            console.log('Socket conectado con ID:', s.id);
            setSocketId(s.id);
        });
        s.on('disconnect', (reason) => {
            console.log('socket disconnect:', reason);
        });
        s.on('connect_error', (err) => {
            console.error('connect_error:', err?.message, err);
        });
        s.on('error', (err) => {
            console.error('socket error:', err);
        });

        return () => {
            s.off();
            s.close(); // cierra limpio
        };
    }, []);

//    useEffect(() => {
//        const newSocket = io(process.env.REACT_APP_URLSOCKETIO, {
//            transports: ['websocket']
//        });
    
//        setSocket(newSocket);
    
//        newSocket.on('connect', () => {
//            console.log('Socket conectado con ID:', newSocket.id);
//            setSocketId(newSocket.id);
//        });
    
//        return () => newSocket.disconnect();
//    }, []);

    const setUserLogin = (e) => {
        setUser(e.target.value)
    }

    const setTypeUser = (e) => {
        /*this.setState({userType: event.target.value});*/
        setUserType(e.target.value)

    }

    const setPassword = (e) => {
        /*this.setState({pass: event.target.value});*/
        setPass(e.target.value)
    }

    const login = async (e) => {
        const data = {
            profile_id: userType,
            mail: user,
            password: pass,
            socket_id: socketId, 
        };

        const userLogin = await Axios.get(process.env.REACT_APP_URLAUTENTICATE, {
            params: {
                profile_id: userType,
                mail: user,
                password: pass,
                socket_id: socketId 
            },
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then(res => statuscall = res).catch(err => statuscall = err.response);

        if (statuscall.status == 200) {
            clearImpersonationState()
            window.localStorage.setItem('MY_APP_STATE_USER', JSON.stringify(user))
            window.localStorage.setItem('MY_APP_STATE_APIKEY', JSON.stringify(statuscall.data.ApiKey))
            window.localStorage.setItem('MY_APP_STATE_AUTHCODE', JSON.stringify(statuscall.data.AuthCode))
            window.localStorage.setItem('MY_APP_STATE_ROLE', JSON.stringify(statuscall.data.roles))
            window.localStorage.setItem('MY_APP_STATE_PROF_ID', JSON.stringify(statuscall.data.perfil.id_perfil))
            window.localStorage.setItem('MY_APP_STATE_PROF_NAME', JSON.stringify(statuscall.data.perfil.fullname))
            window.localStorage.setItem('MY_APP_STATE_PROF_PROF', JSON.stringify(statuscall.data.perfil.perfil))
            window.localStorage.setItem('MY_APP_STATE_PROV_VALOR', JSON.stringify(statuscall.data.perfil.valor_ticket))
            window.localStorage.setItem('MY_APP_STATE_PROF_CASINO', JSON.stringify(statuscall.data.perfil.casino))
            window.localStorage.setItem('MY_APP_STATE_PROF_CASINO_ID', JSON.stringify(statuscall.data.perfil.casino_id))
            window.localStorage.setItem('MY_APP_STATE_PROF_TIENE_IMPRESORA', JSON.stringify(statuscall.data.perfil.tiene_impresora))
            window.localStorage.setItem('MY_APP_STATE_PROF_IMPRESORA', JSON.stringify(statuscall.data.perfil.impresora))
            setAlertClass('success')
            setAlertHead(statuscall.data.MessageCode)
            setAlertBody(statuscall.data.Message)
            setAlertActivate(true)
            setTimeout(() => {
                setAlertActivate(false)
                navigate('/Home/' + statuscall.data.AuthCode)
            }, 2000)
        } else {
            setAlertClass('danger')
            setAlertHead(statuscall.data.MessageCode)
            setAlertBody(statuscall.data.Message)
            setAlertActivate(true)
            setTimeout(() => {
                setAlertActivate(false)
            }, 5000)
        }
    }

    return (
        <div className='justify-center w-full content-center items-center object-center flex mt-4'>
            <div className='justify-center w-full content-center items-center object-center lg:max-w-lg flex max-w-sm flex-col gap-24'>
                <div className='flex-col w-full justify-center gap-2 flex'>
                    <div className='text-center'>
                        <h1>Iniciar sesión</h1>
                    </div>

                    <Form.Group controlId="formUserType">
                        <Form.Label>Tipo de usuario</Form.Label>
                        <Form.Select aria-label="Default select example" onChange={setTypeUser}>
                            {profileList}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group controlId="formEmail" className="">
                        <Form.Label>Correo electrónico</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="name@example.com"
                            onChange={setUserLogin}
                        />
                    </Form.Group>

                    <Form.Group controlId="formPassword" className="">
                        <Form.Label>Contraseña</Form.Label>
                        <Form.Control
                            type="password"
                            placeholder="****************"
                            onChange={setPassword}
                        />
                    </Form.Group>

                    {alertActivate && (
                        <div className="mt-2">
                            <Alert variant={alertClass} onClose={() => setAlertActivate(false)} dismissible>
                                <Alert.Heading>{user}</Alert.Heading>
                                <p>{alertBody}</p>
                            </Alert>
                        </div>
                    )}

                    <div className="d-grid gap-2 w-full">
                        <Button variant="primary" size="lg" onClick={login}>
                            Ingresar
                        </Button>
                        <Link to={`/RecoverPassword`}
                              className="text-right no-underline">Recuperar contraseña</Link>
                    </div>
                </div>
                
                <div className="w-full text-center gap-2 flex flex-col">
                    <span>¿Aún no estás registrado?</span>
                    <Link to={`/Register`} className="w-full">
                        <button
                            className="border-[#aa0047] border-1 w-full text-black hover:bg-[#aa0047] hover:bg-opacity-40 h-12 rounded-md text-lg"
                        >Registrarme
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default Bodylogin
